<template>
  <van-popup
    get-container="body"
    :value="value"
    :close-on-click-overlay="false"
    @input="$emit('input', $event)"
  >
    <div
      class="expired_popup"
      :class="[
        isThemedExpiredPopup ? 'expired_popup--themed' : 'expired_popup--legacy',
        `expired_popup--${themeId}`,
      ]"
      id="animation"
    >
      <section v-if="isThemedExpiredPopup" class="expired_popup_card">
        <div class="expired_popup_visual">
          <img
            v-if="expiredHero"
            class="expired_popup_hero"
            :src="expiredHero"
            alt=""
          />
          <div class="expired_popup_icon">
            <img v-if="warningIcon" :src="warningIcon" alt="" />
            <span v-else>!</span>
          </div>
        </div>
        <h3 class="expired_popup_title">{{ $t('text_transaction_expired') }}</h3>
      </section>

      <div v-else class="main_box">
        <div class="computer_pay_header_time_info">
          <img class="computer_pay_header_time_info_img" src="@/assets/cardPay_GH/popupimg.png" alt="">
        </div>
        <div class="title">{{$t('text_transaction_expired')}}</div>
        <!-- <img @click="clickOnThe" class="close_img" src="@/assets/cardPay_NG/close.png" alt=""> -->
      </div>
    </div>
  </van-popup>
</template>
<script>
import themeMixin from '@/mixins/theme';

export default {
  mixins: [themeMixin],
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isThemedExpiredPopup() {
      return ['self-blue', 'custom-gold'].includes(this.themeId);
    },
    expiredHero() {
      if (this.themeId === 'custom-gold') {
        return this.themeImg('copyPayHero') || this.themeImg('entryHero') || '';
      }
      return this.themeImg('copyPayHero') || this.themeImg('entryHero') || '';
    },
    warningIcon() {
      return this.themeImg('warningIcon') || '';
    },
  },
  methods: {
    clickOnThe() {
      this.$emit('input', !this.value)
      window.opener = null;
      window.open('', '_self');
      window.close();
    },
  }
}
</script>
<style lang="scss" scoped>
.expired_popup {
  box-sizing: border-box;
}

.expired_popup--themed {
  width: min(327px, calc(100vw - 48px));
}

.expired_popup_card {
  position: relative;
  width: 100%;
  min-height: 245px;
  padding: 22px 22px 24px;
  border: 1px solid var(--pay-color-border-lighter);
  border-radius: 8px;
  background: var(--pay-color-bg-card);
  box-shadow: 0 12px 34px var(--pay-color-bg-overlay);
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;
}

.expired_popup_visual {
  position: relative;
  height: 132px;
  border-radius: 8px;
  background: var(--pay-color-bg-secondary);
  overflow: hidden;
}

.expired_popup_hero {
  position: absolute;
  right: 19px;
  bottom: 3px;
  width: 126px;
  height: 126px;
  object-fit: contain;
}

.expired_popup_icon {
  position: absolute;
  left: 24px;
  top: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--pay-color-danger-bg);
  box-shadow: 0 6px 16px var(--pay-color-bg-overlay);
}

.expired_popup_icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.expired_popup_icon span {
  color: var(--pay-color-danger);
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}

.expired_popup_title {
  margin: 20px auto 0;
  max-width: 250px;
  color: var(--pay-color-text-primary);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.expired_popup--self-blue .expired_popup_card {
  padding-top: 24px;
}

.expired_popup--self-blue .expired_popup_visual {
  background: #f6f9ff;
}

.expired_popup--self-blue .expired_popup_hero {
  right: 11px;
  bottom: -7px;
  width: 142px;
  height: 142px;
}

.expired_popup--self-blue .expired_popup_icon {
  left: 27px;
  background: #f8f1f2;
}

.expired_popup--custom-gold .expired_popup_card {
  min-height: 253px;
  padding: 0 0 24px;
  border-color: #fae9cf;
}

.expired_popup--custom-gold .expired_popup_visual {
  height: 140px;
  border-radius: 8px 8px 0 0;
  background: linear-gradient(-23deg, #392812 0.6%, #171716 79.5%);
}

.expired_popup--custom-gold .expired_popup_hero {
  right: 26px;
  bottom: 9px;
  width: 106px;
  height: 121px;
}

.expired_popup--custom-gold .expired_popup_icon {
  left: 30px;
  top: 42px;
  background: rgba(255, 243, 242, 0.96);
}

.expired_popup--custom-gold .expired_popup_title {
  margin-top: 22px;
  color: var(--pay-color-text-primary);
}

.main_box {
  position: relative;
  width: 275px;
  height: 250px;
  background: #FFFFFF;
  border-radius: 15px;
  padding-top: 25px;
  box-sizing: border-box;

  .title {
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #404960;

    text-align: center;
    margin-top: 20px;
  }

  .computer_pay_header_time_info {
    display: flex;
    align-items: center;
    justify-content: center;

    .computer_pay_header_time_info_img {
      width: 173px;
      height: 157px;
    }
  }

  .close_img {
    position: absolute;
    width: 35px;
    height: 35px;
    left: 50%;
    bottom: -15px;
    transform: translate(-50%, 100%);
    cursor: pointer;
  }
}

.expired_popup--legacy {
  height: 350px;
  /*left: -250px;*/
  /*top: -250px;*/

}

/*//左右摆动动画*/
#animation {
  -webkit-animation: wobble 1s 0.2s ease both;
  -moz-animation: wobble 1s 0.2s ease both;
}

@-webkit-keyframes wobble {
  0% {
    -webkit-transform: translateX(0%);
  }
  15% {
    -webkit-transform: translateX(-25%) rotate(-5deg);
  }
  30% {
    -webkit-transform: translateX(20%) rotate(3deg);
  }
  45% {
    -webkit-transform: translateX(-15%) rotate(-3deg);
  }
  60% {
    -webkit-transform: translateX(10%) rotate(2deg);
  }
  75% {
    -webkit-transform: translateX(-5%) rotate(-1deg);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-moz-keyframes wobble {
  0% {
    -moz-transform: translateX(0%);
  }
  15% {
    -moz-transform: translateX(-25%) rotate(-5deg);
  }
  30% {
    -moz-transform: translateX(20%) rotate(3deg);
  }
  45% {
    -moz-transform: translateX(-15%) rotate(-3deg);
  }
  60% {
    -moz-transform: translateX(10%) rotate(2deg);
  }
  75% {
    -moz-transform: translateX(-5%) rotate(-1deg);
  }
  100% {
    -moz-transform: translateX(0%);
  }
}

</style>
